module.exports = __webpack_public_path__ + "static/media/logo3bunexe.555086ca.jpg";